/**
 * 
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath"
import { MainRequest } from "@/core/request";

export default class ContactInformationRequest extends MainRequest {

    static update(data) {
        return this.postSEC(ServicePath.CONTACT_INFORMATION_UPDATE_PROFILE, data);
    }
}